/** `?agent=1` (sticky for the tab): no autoplay, no animation, no hover-only UI. Bots should use it. */
const KEY = "vp.agentMode";

export function isAgentMode(): boolean {
  if (typeof window === "undefined") return false;
  const q = new URLSearchParams(window.location.search).get("agent");
  try {
    if (q === "1") sessionStorage.setItem(KEY, "1");
    if (q === "0") sessionStorage.removeItem(KEY);
    return q === "1" || sessionStorage.getItem(KEY) === "1";
  } catch {
    return q === "1";
  }
}

export function applyAgentMode(): void {
  if (typeof document !== "undefined") document.documentElement.classList.toggle("agent", isAgentMode());
}
